import { Box, Typography } from "@mui/material";
import BarChartIcon from "@mui/icons-material/BarChart";
import GraphCard from "./GraphCard";
import { getCategoryIcon } from "./categoryMeta";
import "../styles/analytics.scss";

// ─── Container: renders a GraphCard per graph in the selected category ────────
const AnalyticsGraph = ({ selectedGraph, onPinnedChange, analyticsFilterMenu }) => {
  const graphs = selectedGraph?.graphsData;
  const hasGraphs = Array.isArray(graphs) && graphs.length > 0;

  if (!hasGraphs) {
    return (
      <Box className="analytics-empty-state">
        <BarChartIcon className="analytics-empty-icon" />
        <Typography variant="body2" className="analytics-empty-text" > Select a category from the sidebar to view its charts </Typography>
      </Box>
    );
  }

  const CategoryIcon = getCategoryIcon(selectedGraph?.title);
  const fillAvailableHeight = graphs.length === 1;

  return (
    <Box className="analytics-graph-list">
      <Box className="analytics-category-header">
        <Box className="analytics-category-icon-wrap">
          <CategoryIcon className="analytics-category-icon" />
        </Box>
        <Box className="analytics-category-heading">
          <Typography className="analytics-category-title">{selectedGraph?.title}</Typography>
          <Typography className="analytics-category-count"> {graphs.length} {graphs.length === 1 ? "chart" : "charts"} </Typography>
        </Box>
      </Box>
      <Box className="analytics-graph-scroll">
        {graphs.map((graph) => (
          <GraphCard
            key={graph.uuid ?? graph.id}
            graph={graph}
            onPinnedChange={onPinnedChange}
            analyticsFilterMenu={analyticsFilterMenu}
            fillAvailableHeight={fillAvailableHeight}
          />
        ))}
      </Box>
    </Box>
  );
};

export default AnalyticsGraph;
